import React, { useEffect, useState, useContext } from 'react';
import { AddUserDataContext } from 'context/AddUserContext';
import RadioButton from 'sub_components/Common/Radio';
import styled from 'styled-components';
import { Utils } from 'services/utils';

const PREFERENCES = {
	YES: 'Yes',
	NO: 'No - (Guest will be escorted.)',
};
const OPTIONS = [
	{ name: PREFERENCES.YES, value: PREFERENCES.YES },
	{ name: PREFERENCES.NO, value: PREFERENCES.NO },
];
const BadgeStyle = styled.div`
	.badge-access-wrapper {
		.badge-info{
			color: ${props => props.theme.Med_Rust}
		}
		.radio-wrapper {
			width: 450px;
			.radio-selection {
				margin-bottom: 50px;
				.radio-label{
					margin 4px 12px 0 45px;
					width:275px;
				}
				.check{
					margin-top:-3px;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
	props.theme.res.high}) {
		.badge-access-wrapper {
			.radio-wrapper {
				width: 450px;
				.radio-selection {
					margin-bottom: 50px;
					.radio-label{
						margin 4px 12px 0 45px;
						width:390px;
					}
					.check{
						margin-top:-3px;
					}
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.badge-access-wrapper {
			.radio-wrapper {
				width: 450px;
				.radio-selection {
					margin-bottom: 50px;
					.radio-label{
						margin 4px 12px 0 45px;
						width:600px;
					}
					.check{
						margin-top:-3px;
					}
				}
			}
		}
	}
`;

export const BadgeScreen = ({ rosterUser }) => {
	const { inputs, change } = useContext(AddUserDataContext);
	const [badges, setBadges] = useState(null);
	const datacenters = rosterUser?.datacenterList;

	function handleChange(badgeAccess) {
		change({ target: { name: 'badgeAccess', value: badgeAccess } });
	}

	function checkLocationBadge() {
		const selectedLocations = inputs?.locations;
		const selectedBadges = [];
		for (let i = 0; i <= datacenters?.length - 1; i++) {
			selectedLocations.map(location => {
				if (
					Utils.getLocationNameByTag(datacenters[i]?.datacenter) === location &&
					!datacenters[i]?.escort_required
				) {
					selectedBadges.push(location);
				}
			});
		}

		setBadges(selectedBadges);
	}
	function getText() {
		let text = '';

		if (badges?.length === 1) {
			text = `This users badge for ${badges?.[0]} will be revoked and a new badge issued.`;
		} else {
			const locations = badges.join(', ');

			text = `This users badges for ${locations} will be revoked and a new badge issued.`;
		}

		return text;
	}

	useEffect(() => {
		checkLocationBadge();
	}, []);

	return (
		<BadgeStyle>
			<div className='badge-access-wrapper'>
				<RadioButton
					callback={handleChange}
					name='badgeAccess'
					value={inputs.badgeAccess}
					hidden={false}
					toggle={true}
					options={OPTIONS}
					cypressId='dc'
					id='dc'
				/>
				{badges && badges?.length !== 0 && inputs?.badgeAccess === 'Yes' && (
					<div className='badge-info body10'>{getText()}</div>
				)}
			</div>
		</BadgeStyle>
	);
};
